// search form validation
$(function () {
    $('.search-form').validate({

        rules: {
            q: {
                required: true,
                minlength: 2
            }
        },

        messages: {
            q: {
                required: 'Please enter your search',
                minlength: 'Please enter at least two characters'
            }
        }

    });

    $('.search-form-mob').validate({

        rules: {
            q: {
                required: true,
                minlength: 2
            }
        },

        messages: {
            q: {
                required: 'Please enter a search term...',
                minlength: 'Please enter at least two characters...'
            }
        }

    });

});